import { EmployerWithTasks } from './data';

export const createTaskCountsFromEmployers = (employers: Array<EmployerWithTasks>): Record<string, number> => {
  return employers.reduce(
    (acc, employer) => {
      if (employer?.id && employer?.tasks?.count !== undefined) {
        acc[employer.id] = employer.tasks.count;
      }
      return acc;
    },
    {} as Record<string, number>
  );
};
